import { useState, useEffect } from "react";
import { ArrowRight, ChevronLeft, Minus, Plus, X } from "lucide-react";
import { Button } from "@components/ui/button";
import { useNavigate } from "react-router";
import { IoAdd } from "react-icons/io5";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import * as Select from "@radix-ui/react-select";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { addWebsiteContentSearchKeywords, removeWebsiteContentSearchKeywords, saveFiltersState, updateWebsiteContentFilters } from "@redux/slices/filter";

interface Props {
  handleClose: () => void;
}

const WebsiteContent: React.FC<Props> = ({ handleClose }) => {
  const [searchKeyword, setSearchKeyword] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialWebsiteContent = useSelector(
    (state: RootState) =>
      state.filter?.companyFilters?.websiteContent?.searchOptions || {
        option1: "",
        option2: "",
        option3: "",
      }
  );
  const searchKeywords = useSelector(
    (state: RootState) =>
      state.filter?.companyFilters?.websiteContent?.searchKeywords || []
  );

  const data=useSelector((state: RootState)=>state.filter);

  const [selectOptions, setSelectOptions] = useState(initialWebsiteContent);
  console.log(searchKeywords);

  const handleKeywordAdd = (keyword: string) => {
    console.log(keyword);
    if (!searchKeywords?.includes(keyword)) {
      dispatch(addWebsiteContentSearchKeywords(keyword));
      setSearchKeyword("");
    }
  };

  const handleKeywordRemove = (keyword: string) => {
    console.log(keyword);
    if (searchKeywords?.includes(keyword)) {
      dispatch(removeWebsiteContentSearchKeywords(keyword));
    }
  };
  useEffect(() => {
    console.log(selectOptions,initialWebsiteContent);
  }, [initialWebsiteContent]);

  const handleSelectChange = (option: string, value: string) => {
    const updatedOptions = { ...selectOptions, [option]: value };
    setSelectOptions(updatedOptions);
    dispatch(updateWebsiteContentFilters(updatedOptions));
  };

  return (
    <div className="flex flex-col justify-between h-full p-8">
      <div>
        <div className="flex justify-between items-center mb-5">
          <h4 className="text-xl font-bold flex items-center -ms-2">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Website Content
          </h4>
          <X onClick={handleClose} className="cursor-pointer" />
        </div>
        <p className="text-gray font-medium my-3">
          Find companies whose website contains any of the following keywords:
        </p>
        <div className="flex gap-4">
        <div className="w-2/3">
            <div className="relative mb-8">
              <input
                className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm  transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
                id="username"
                type="text"
                placeholder="Search"
                onChange={(e) => setSearchKeyword(e.target.value)}
                value={searchKeyword}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleKeywordAdd(searchKeyword); // Call your function when Enter is pressed
                    setSearchKeyword('');
                   
                  }
                }}
              />

              <div className="absolute left-0 inset-y-0 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#71717A"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <div className="absolute right-[10px] inset-y-0 flex items-center">
                {/* <Minus className="cursor-pointer me-4" /> */}
                <Plus
                  className="cursor-pointer"
                  onClick={() => handleKeywordAdd(searchKeyword)}
                />
              </div>
            </div>
          <div className="flex items-center gap-4 flex-wrap  overflow-y-scroll h-60">
              {searchKeywords?.map((val: string, index: number) => {
                return (
                  <div className="bg-white p-8 rounded-lg flex justify-between border-b w-1/2 px-4 py-3 mb-2">
                    <p>{val}</p>
                    <X
                      onClick={() => handleKeywordRemove(val)}
                      className="cursor-pointer"
                      size={20}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          {/* <div className="bg-white rounded-lg w-1/3 px-6 py-4">
            <h4 className="text-lg font-bold flex items-center mb-3">
              Search Options
            </h4>
            <Select.Root
              value={selectOptions.option1}
              onValueChange={(value) => handleSelectChange("option1", value)}
            >
              <SelectTrigger className="SelectTrigger bg-white">
                <SelectValue placeholder="All website URLs" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="opt1">option 1</SelectItem>
                <SelectItem value="opt2">option 2</SelectItem>
                <SelectItem value="opt3">option 3</SelectItem>
              </SelectContent>
            </Select.Root>
            <div className="my-2"></div>
            <Select.Root
              value={selectOptions.option2}
              onValueChange={(value) => handleSelectChange("option2", value)}
            >
              <SelectTrigger className="SelectTrigger bg-white">
                <SelectValue placeholder="Another option" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="opt1">option 1</SelectItem>
                <SelectItem value="opt2">option 2</SelectItem>
                <SelectItem value="opt3">option 3</SelectItem>
              </SelectContent>
            </Select.Root>
            <div className="my-2"></div>
            <Select.Root
              value={selectOptions.option3}
              onValueChange={(value) => handleSelectChange("option3", value)}
            >
              <SelectTrigger className="SelectTrigger bg-white">
                <SelectValue placeholder="Yet another option" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="opt1">option 1</SelectItem>
                <SelectItem value="opt2">option 2</SelectItem>
                <SelectItem value="opt3">option 3</SelectItem>
              </SelectContent>
            </Select.Root>
          </div> */}
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={() => navigate(-1)} className="bg-[#1CB5AF]">Save</Button>
      </div>
    </div>
  );
};

export default WebsiteContent;
